import React from 'react'
import { PageLayout } from 'app/views/components/layout/page-layout'
import { AmortizationScheduleDrillPage } from './amortization-schedule-drill-page'


export function AmortizationLandingPage() {
  return (
    <PageLayout>
      <AmortizationScheduleDrillPage />
    </PageLayout>
  )
}
